import React from 'react';
import { Scan } from 'lucide-react';

import UIStrings from '@/Utils/UIStrings';

import CTMonitoringFunctionalityDisabled from './CTMonitoringFunctionalityDisabled';

interface CTMonitoringScreenshotsStubProps {
    isScreenSnapshotsEnabled?: boolean;
}

function CTMonitoringScreenshotsStub({
    isScreenSnapshotsEnabled,
}: CTMonitoringScreenshotsStubProps): React.JSX.Element {
    return (
        <CTMonitoringFunctionalityDisabled
            icon={<Scan className="text-muted-foreground size-6" aria-hidden />}
            message={isScreenSnapshotsEnabled ? UIStrings.ScreenSnapshotsIsMissing : UIStrings.ScreenSnapshotsDisabled}
            className="h-96"
        />
    );
}

export default CTMonitoringScreenshotsStub;
